import BigNumber from 'bignumber.js'
import dayjs from 'dayjs'

export const METRICS = {
  ORDER_COUNT: ['委托订单数', '次', '按委托订单去重，同一订单状态变化不重复计数。'],
  ORDER_AMOUNT: ['委托名义金额', 'USDT', '委托名义金额合计，不是保证金。'],
  TRADE_COUNT: ['撮合成交笔数', '笔', '一张订单分多次成交时计多笔。'],
  FILLED_ORDER_COUNT: ['成交订单数', '单', '发生过成交的订单数，同一订单只计一单。'],
  CLOSED_POSITION_COUNT: ['完整平仓次数', '次', '仓位从形成到完全归零计一次。'],
  TRADE_AMOUNT: ['成交名义金额', 'USDT', '实际成交名义金额合计。'],
  CANCEL_COUNT: ['撤单订单数', '次', '成功撤销的订单数，不包含拒单、过期或撤单失败。'],
  CANCEL_RATE: ['撤单率', '%', '统计时间内创建的订单中，成功撤销订单的占比。'],
  PROFIT_SUM: ['平仓盈利合计', 'USDT', '平仓毛盈亏中正数部分之和，未扣手续费。'],
  LOSS_SUM: ['平仓亏损合计', 'USDT', '平仓毛盈亏中负数部分绝对值之和。'],
  REALIZED_PNL: ['平仓毛盈亏', 'USDT', '已实现平仓盈亏合计，未扣手续费。'],
  NET_PNL: ['平仓净盈亏', 'USDT', '完整结束仓位的平仓盈亏减开平仓手续费，加对应资金费收支。'],
  GROSS_WIN_RATE: ['毛盈利胜率', '%', '平仓毛盈亏大于0的完整平仓次数占比。'],
  WIN_RATE: ['净盈利胜率', '%', '平仓毛盈亏减开平仓手续费后大于0的完整平仓次数占比，不额外计入资金费。'],
  SYMBOL_WIN_RATE: ['净盈利胜率', '%', '按单合约统计净盈利完整平仓次数占比。'],
  POSITION_VALUE: ['当前持仓名义价值', 'USDT', '按标记价格计算，多空名义价值取绝对值后相加。'],
  POSITION_MARGIN: ['当前持仓保证金', 'USDT', '当前仓位初始保证金合计，不含挂单保证金。'],
  POSITION_COUNT: ['当前持仓数', '个', '当前非零仓位个数，不是合约张数。'],
  POSITION_AGE: ['当前最长持仓时长', '秒', '当前仓位从首次开仓成交至今的最长时长。'],
  AVG_HOLD_TIME: ['已平仓平均持仓时长', '秒', '完全关闭仓位从首次开仓到完全平仓的平均时长。'],
  UNREALIZED_PNL: ['当前浮动盈亏', 'USDT', '按标记价格计算的浮动盈亏合计。'],
  MAX_LEVERAGE: ['当前最高杠杆', '倍', '当前非零仓位的最高杠杆；单合约按各合约分别取最高值。'],
  MIN_LEVERAGE: ['当前最低杠杆', '倍', '当前非零仓位的最低杠杆；单合约按各合约分别取最低值。'],
  TRANSFER_IN: ['划入金额', 'USDT', '成功划入合约账户的金额合计。'],
  TRANSFER_OUT: ['划出金额', 'USDT', '成功划出合约账户的金额合计。'],
  NET_TRANSFER: ['净划入金额', 'USDT', '成功划入减成功划出金额。'],
}
export const ACTIONS = [
  ['LARK', '发 Lark'], ['DISABLE_OPEN', '关闭开仓'], ['DISABLE_CLOSE', '关闭平仓'],
  ['DISABLE_TRADE', '关闭交易'], ['MARK_ABNORMAL', '标记异常账户'],
  ['DISABLE_TRANSFER', '关闭合约划转'], ['ENABLE_REBATE_RISK', '开启返佣风控'],
  ['ENABLE_CFD', '开启 CFD'], ['ENABLE_ORDER_CAPTCHA', '下单图形验证'],
]
export const OPERATORS = { GTE: '大于等于', GT: '大于', LTE: '小于等于', LT: '小于', EQ: '等于', NE: '不等于', BETWEEN: '介于' }
export const UNITS = [['SECOND', '秒'], ['MINUTE', '分钟'], ['HOUR', '小时'], ['DAY', '天']]
export const clone = value => JSON.parse(JSON.stringify(value))
export const errorText = error => (error && error.message) || (typeof error === 'string' ? error : '操作失败，请重试')
export const timeText = value => !value ? '-' : dayjs(value).isValid() ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-'
export const conditions = node => node.kind === 'CONDITION' ? [node] : node.children.reduce((all, item) => all.concat(conditions(item)), [])
export const metricOf = node => METRICS[node.metric] || [node.metric, '', '']
export const scopeText = node => ['TRANSFER_IN', 'TRANSFER_OUT', 'NET_TRANSFER'].includes(node.metric)
  ? '合约账户' : (node.scope || (node.metric === 'SYMBOL_WIN_RATE' ? 'SYMBOL' : 'ALL')) === 'SYMBOL' ? '任一合约的' : '全部合约的'
export function sentence(node, cell) {
  const metric = metricOf(node)
  const unit = UNITS.find(item => item[0] === cell.window.unit)
  const period = cell.window.type === 'ROLLING' ? `最近${cell.window.amount}${unit ? unit[1] : ''}内，`
    : cell.window.type === 'LIFETIME' ? '历史累计，' : ''
  return `${period}${scopeText(node)}${metric[0]}${OPERATORS[node.operator]} ${cell.value}${node.operator === 'BETWEEN' ? ` 至 ${cell.upper}` : ''} ${metric[1]}${node.operator === 'BETWEEN' ? '（含上下限）' : ''}`
}
export function actionText(action) {
  const item = ACTIONS.find(option => option[0] === action.type)
  return `${item ? item[1] : action.type}${action.type === 'ENABLE_CFD' ? `（市价滑点 ${action.slippageLow} 至 ${action.slippageHigh}）` : ''}`
}
export function nextLevel(levels) {
  const next = clone(levels[levels.length - 1])
  next.id = `level_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
  next.name = `${['一', '二', '三', '四', '五', '六', '七', '八'][levels.length]}级`
  while (levels.some(level => level.name === next.name)) next.name += '副本'
  return next
}
export function payload(form) {
  const result = { name: form.name, priority: form.priority, remark: form.remark, enabled: form.enabled, config: form.config }
  if (form.id) result.id = form.id
  return result
}
export function validate(form) {
  if (!form.name || !form.name.trim() || form.name.trim().length > 100) return '策略名称不能为空且不能超过100字'
  if (!Number.isInteger(Number(form.priority)) || Number(form.priority) < 1 || Number(form.priority) > 2147483647) return '优先级须为1至2147483647的整数'
  if ((form.remark || '').length > 500) return '备注不能超过500字'
  const { snapshot, levels } = form.config
  if (!snapshot || !snapshot.root) return '规则组合未加载'
  if (!levels.length || levels.length > 8) return '请配置1至8个等级'
  const names = new Set()
  for (const level of levels) {
    const name = (level.name || '').trim()
    if (!name || name.length > 30 || names.has(name)) return '等级名称不能为空、重复或超过30字'
    names.add(name)
    if (!level.actions.length) return `${name}：请至少选择一项措施`
    for (const action of level.actions) {
      if (action.type !== 'ENABLE_CFD') continue
      if ([action.slippageLow, action.slippageHigh].some(value => !/^(0|[1-9][0-9]{0,23})(\.[0-9]{1,6})?$/.test(value || '') || new BigNumber(value).gt('0.1')))
        return `${name}：CFD市价滑点须为0至0.1，最多6位小数`
      if (new BigNumber(action.slippageLow).gt(action.slippageHigh)) return `${name}：CFD滑点上限不能小于下限`
    }
    for (const node of conditions(snapshot.root)) {
      const cell = level.values[node.id]
      const label = `${name}，${metricOf(node)[0]}`
      if (!cell || !cell.window) return `${label}：缺少参数`
      const values = node.operator === 'BETWEEN' ? [cell.value, cell.upper] : [cell.value]
      for (const value of values) {
        if (!/^-?(0|[1-9][0-9]{0,23})(\.[0-9]{1,12})?$/.test(value || '')) return `${label}：请输入有效数值，最多12位小数`
        const amount = new BigNumber(value)
        if (!['REALIZED_PNL', 'NET_PNL', 'UNREALIZED_PNL', 'NET_TRANSFER'].includes(node.metric) && amount.lt(0)) return `${label}：不能为负数`
        if (['ORDER_COUNT', 'TRADE_COUNT', 'FILLED_ORDER_COUNT', 'CLOSED_POSITION_COUNT', 'CANCEL_COUNT', 'POSITION_COUNT', 'MAX_LEVERAGE', 'MIN_LEVERAGE'].includes(node.metric) && !amount.isInteger()) return `${label}：须为整数`
        if (metricOf(node)[1] === '%' && amount.gt(100)) return `${label}：不能超过100%`
      }
      if (node.operator === 'BETWEEN' && new BigNumber(cell.value).gt(cell.upper)) return `${label}：区间上限不能小于下限`
      if (cell.window.type === 'ROLLING') {
        const factor = { SECOND: 1, MINUTE: 60, HOUR: 3600, DAY: 86400 }[cell.window.unit]
        if (!/^[1-9][0-9]{0,7}$/.test(cell.window.amount) || !factor || Number(cell.window.amount) * factor > 90 * 86400)
          return `${label}：统计时间须为正整数且不超过90天`
      }
    }
  }
  return ''
}
